import Navbar from "@/components/Navbar";
import FeatureCauseForApplause from "@/components/FeatureCauseForApplause";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import ConnectionMoment from "@/components/ConnectionMoment";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import { usePageSEO } from "@/hooks/usePageSEO";

const PAGE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Event",
  "@id": "https://garyzelesky.com/cause-for-applause",
  "name": "Cause for Applause — Referring Doctor Appreciation Experience",
  "description": "A signature done-for-you appreciation experience designed for dental specialists to thank referring doctors and re-energize their teams. Led by 30-year keynote speaker Gary Zelesky.",
  "url": "https://garyzelesky.com/cause-for-applause",
  "organizer": {
    "@type": "Person",
    "name": "Gary Zelesky",
    "url": "https://garyzelesky.com/"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://garyzelesky.com/cause-for-applause#book",
    "availability": "https://schema.org/InStock"
  }
};

export default function CauseForApplausePage() {
  usePageSEO({
    title: "Cause for Applause | Referring Doctor Appreciation Event by Gary Zelesky",
    description: "Cause for Applause by Gary Zelesky — the ultimate done-for-you referring doctor appreciation experience for dental specialists. Strengthen referral relationships, re-energize your team, host a night guests call 'one of the best ever attended.'",
    canonical: "https://garyzelesky.com/cause-for-applause",
    schema: PAGE_SCHEMA,
    schemaId: "cfa-page-schema",
  });

  return (
    <div data-testid="cfa-page" className="bg-[#050505] text-white">
      <Navbar />
      {/* Page hero with H1 for SEO */}
      <section className="pt-32 pb-8 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-12 bg-[#EC1985]" />
            <span className="eyebrow">Referring Doctor Appreciation</span>
          </div>
          <h1 className="h-display text-4xl md:text-6xl lg:text-7xl max-w-5xl">
            Cause for Applause — The Signature Referring Doctor Appreciation Event.
          </h1>
          <p className="mt-6 text-white/85 text-lg md:text-xl max-w-3xl">
            A done-for-you appreciation experience designed to help dental specialists honor
            their referring doctors, strengthen relationships, and re-energize their own teams.
          </p>
        </div>
      </section>
      <FeatureCauseForApplause />
      <HowItWorks />
      <Testimonials />
      <ConnectionMoment />
      <BookingForm />
      <FAQ />
      <Footer />
    </div>
  );
}
